import React, { useContext } from "react";
import { Route, Navigate, useNavigate } from "react-router";
import { UserContext } from "./User";
import Cookies from "js-cookie";
import { updateDoc } from "firebase/firestore";
import { async } from "@firebase/util";
// import Auth from "./use-auth";

export default function ProtectedRoute({ children }) {
	const navigate = useNavigate();
	const onRedirectCallback = (appState) => {
		navigate(appState?.returnTo || window.location.pathname);
	};

	if (Cookies.get().lastLogin && Cookies.get().id) {
		// console.log(new Date().getTime());
		// let hours = Math.abs(
		// 	Math.round(new Date().getTime() / 1000 - Cookies.get().lastLogin) / 36e5
		// );

		let hours =
			Math.floor((Date.now() - Cookies.get().lastLogin) / 1000) / 3600;
		// console.log(hours);
		if (hours > 1) {
			console.log("Hrs > 1");
			Cookies.set("lastLogin", Date.now());
			async () => {
				const user_ref = await doc(db, "users", Cookies.get().id);
				await updateDoc(user_ref, {
					lastLogin: Date.now(),
				});
			};
		}
	} else if (Cookies.get().id && !Cookies.get().lastLogin) {
		Cookies.set("lastLogin", Date.now());
		async () => {
			const user_ref = await doc(db, "users", Cookies.get().id);
			await updateDoc(user_ref, {
				lastLogin: Date.now(),
			});
		};
	}

	const { user, setUser } = useContext(UserContext);
	const Auth = Cookies.get().id ? true : false;
	return Auth ? children : <Navigate to="/signup" />;
}
